import { combineEpics } from 'redux-observable';
import { epics as applicationEpics } from '../features/application';
import { epics as cardsEpics } from '../features/service';
import { epics as searchEpics } from '../features/search';

export default combineEpics(applicationEpics, cardsEpics, searchEpics);
